
export enum RoleEnum {
    MasterSystemAdmin = 1,
    SystemAdministrator = 2,
    CredentialingManager = 3,
    Judge = 4,
    SchoolCoordinator = 5,
    Youth = 6
}

export enum DecisionEnum {
    Pending = 1,
    Approved = 2,
    Declined = 3
}

export enum Predicates {
    Equals = 1,
    StartsWith = 2,
    Contains = 3,
    GreaterThan = 4,
    LessThan = 5,
    GreaterThanEquals = 6,
    LessThanEquals = 7
}

export const PageEnum = {
    UserAdmin: "UserAdmin",
    SchoolAdmin: "SchoolAdmin",
    RegionAdmin: "RegionAdmin",
    YouthDashboard: "YouthDashboard",
    SchoolCoordinatorDashboard: "SchoolCoordinatorDashboard",
    AdminDashboard: "AdminDashboard",
    CaseDashboard: "CaseDashboard",
    CaseDetail: "CaseDetail",
    DownloadUserData: "DownloadUserData",
    ManageSponsoredAds: "ManageSponsoredAds"
}